import { ClientId, ConfigProvider as CommonConfigProvider, ConfigUtils, ClientsConfig } from '@nexelem/config';
import { ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CommonLoader } from '../components/atoms/CommonLoader';
import { useAPI } from '@nexelem/api';
import { useDevtoolsStore } from '../DeveloperTools';

type ConfigProviderWrapperProps = {
  children: ReactNode;
};
export const ConfigProvider = ({ children }: ConfigProviderWrapperProps) => {
  const { isLoading, data, error } = useLoadConfig();

  if (isLoading) {
    return <CommonLoader />;
  }

  if (!data || error) {
    throw error;
  }

  return <CommonConfigProvider config={data}>{children}</CommonConfigProvider>;
};

const useLoadConfig = () => {
  const api = useAPI();
  const { getProperty } = useDevtoolsStore.getState();

  return useQuery({
    queryKey: ['app-config'],
    queryFn: async () => {
      const data = await api.getBackDevConfiguration();
      const clientId = getProperty('clientId', data.clientId as ClientId);

      const clientConfig = await ClientsConfig[clientId]();

      return {
        ...data,
        ...clientConfig,
        env: ConfigUtils.getEnvName(data.env),
      };
    },
    retry: 5,
  });
};
